import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Providers } from './app/providers';
import { appRoutes } from './app/router';
import { registerServiceWorker } from './registerServiceWorker';
import './index.css';

registerServiceWorker();

const router = createBrowserRouter(appRoutes);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </React.StrictMode>,
);
